type ResolveKioskShopperNameArgs = {
  /**
   * What the guest answered in the field: `null` while untouched, `""` once
   * they clear it.
   */
  answeredName: string | null | undefined;
  identifiedUserName: string | undefined;
  usesCustomShopperName: boolean;
};

/**
 * The name to put on a kiosk order: what the guest answered, falling back to
 * the name of the guest we identified. `??` rather than `||`, so a field the
 * guest deliberately cleared stays cleared.
 */
export function resolveKioskShopperName({
  answeredName,
  identifiedUserName,
  usesCustomShopperName
}: ResolveKioskShopperNameArgs): string | null {
  if (!usesCustomShopperName) {
    return answeredName ?? null;
  }

  return answeredName ?? identifiedUserName ?? null;
}
